import React, { useEffect, useState } from "react";
import { api_Routes } from "../../tools/api_Routes";
import { Helper } from "../../tools/Helper";
import {
  LinearProgress,
  TablePagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import DataTable from "./data-table";
import { AddButton } from "../Button/AddButton";
import {Can} from "../Can";

export const UsersTable = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [debouncedKeyword, setDebouncedKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedKeyword(keyword);
      setCurrentPage(0);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [keyword]);

  const getData = async () => {
    setIsLoading(true);
    // Build the query string dynamically
    const queryParams = [];
    if (debouncedKeyword) queryParams.push(`name=${debouncedKeyword}`);

    const { response, message } = await Helper.Get({
      url: `${api_Routes.Users.View}?per_page=${rowsPerPage}&page=${
        currentPage + 1
      }${queryParams?.length > 0 ? `&${queryParams}` : ""}`,
      hasToken: true,
    });
    if (response) {
      setData(response);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, [debouncedKeyword, currentPage, rowsPerPage]);

  return (
    <div>
      {/* Filter Section */}
      <div className="flex justify-between items-center mb-3">
        <label className="font-bold inline-block text-textColor dark:text-darkTextColor text-[15px]  text-start">
          Search :
          <input
            placeholder="Write any keyword"
            type="text"
            name="keyword"
            value={keyword}
            onChange={handleKeywordChange}
            autoComplete="off"
            className="duration-200 font-normal bg-secondary dark:bg-darkPrimary text-textColor dark:text-darkTextColor ml-2
                                        border-2 input-box 
                                      rounded-[0.25rem]  py-1 px-3 outline-none"
          />
        </label>

        <Can I="store" a="users">
        <AddButton to="/Users/Add" label="Add User" />
        </Can>
      </div>

      {/* Table and Pagination */}
      {isLoading ? (
        <LinearProgress sx={{ marginTop: 1 }} />
      ) : data && data?.data?.length > 0 ? (
        <>
          <div className="overflow-x-auto">
            <DataTable data={data?.data} />
          </div>
          <div className="mt-4 flex justify-center items-center">
            <TablePagination
              page={currentPage}
              className="mt-auto"
              onPageChange={handlePageChange}
              count={data.pagination.total}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              variant="outlined"
              shape="rounded"
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </div>
        </>
      ) : (
        <TableContainer>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  There are no data yet
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};
